module.exports = __webpack_public_path__ + "static/media/CYROTH_Corte.67f45e45.png";